import React, { useState, useEffect } from 'react';
import Lightbox from './Lightbox';

function ProjetsPage() {
  const [projets, setProjets] = useState([]);
  const [filter, setFilter] = useState('all');
  const [lightbox, setLightbox] = useState({ open: false, images: [], index: 0 });

  useEffect(() => {
    fetch('/projets.json')
      .then(r => r.json())
      .then(setProjets)
      .catch(() => setProjets([]));
  }, []);

  const groups = {};
  projets.forEach(p => {
    if (!groups[p.year]) groups[p.year] = [];
    groups[p.year].push(p);
  });
  const years = Object.keys(groups).sort((a, b) => Number(b) - Number(a));

  function openLightbox(id, year) {
    const folder = '/projets/' + year + '/' + id + '/';
    const images = [];
    const max = 50;

    for (let i = 1; i <= max; i++) {
      images.push(folder + i + '.webp');
    }

    setLightbox({ open: true, images, index: 0 });
  }

  function closeLightbox() {
    setLightbox(prev => ({ ...prev, open: false }));
  }

  function prevImage() {
    setLightbox(prev => ({
      ...prev,
      index: (prev.index - 1 + prev.images.length) % prev.images.length,
    }));
  }

  function nextImage() {
    setLightbox(prev => ({
      ...prev,
      index: (prev.index + 1) % prev.images.length,
    }));
  }

  const displayed = filter === 'all'
    ? groups
    : { [filter]: groups[filter] || [] };

  return (
    <div className="section page-content" style={{ padding: '100px 0', flex: 1 }}>
      <div style={{ background: 'rgba(255,255,255,0.88)', padding: '60px 0', borderRadius: 8, margin: '0 15px' }}>
        <div className="section-title">
          <h2>Vos Projets</h2>
          <div className="title-bar"></div>
          <p className="section-subtitle">Découvrez nos réalisations</p>
        </div>

        <div className="container">
          <div className="projets-filters" style={{ textAlign: 'center', marginBottom: 40 }}>
            <button onClick={() => setFilter('all')} style={btnStyle(filter === 'all')}>Toutes</button>
            {years.map(y => (
              <button key={y} onClick={() => setFilter(y)} style={btnStyle(filter === y)}>{y}</button>
            ))}
          </div>

          {Object.entries(displayed).map(([year, projets]) => (
            <div key={year} className="year-group" style={{ marginBottom: 50 }}>
              <h3 style={{ fontSize: 24, marginBottom: 20, color: 'var(--dark)', borderBottom: '3px solid var(--primary)', paddingBottom: 8 }}>{year}</h3>
              <div className="card-grid">
                {projets.map(p => (
                  <div key={p.id} className="card" onClick={() => openLightbox(p.id, p.year)} style={{ cursor: 'pointer' }}>
                    <img src={'/projets/' + p.year + '/' + p.id + '/1.webp'} alt={p.title} loading="lazy" style={{ width: '100%', height: 220, objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
                    <div className="card-body">
                      <div style={{ fontSize: 12, color: 'var(--primary)', fontWeight: 700, marginBottom: 5 }}>{p.year}</div>
                      <h3 style={{ fontSize: 18, marginBottom: 8 }}>{p.title}</h3>
                      <p style={{ color: 'var(--text-light)', fontSize: 14 }}>{p.description || ''}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightbox.open && (
        <Lightbox images={lightbox.images} index={lightbox.index} onClose={closeLightbox} onPrev={prevImage} onNext={nextImage} />
      )}
    </div>
  );
}

function btnStyle(active) {
  return {
    background: active ? 'var(--primary)' : 'transparent',
    color: active ? 'var(--dark)' : 'var(--text)',
    border: '2px solid var(--primary)',
    padding: '8px 20px',
    margin: '0 5px 10px',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
    transition: '0.3s ease'
  };
}

export default ProjetsPage;
